import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { AdminLayout } from "@/components/admin/AdminLayout";
const AdminQuizLeads = lazy(() => import("@/pages/admin/AdminQuizLeads"));
export const Route = createFileRoute("/admin/quiz-leads")({
  component: () => (
    <AdminLayout requiredPermission="view_audit_logs">
      <AdminQuizLeads />
    </AdminLayout>
  ),
});
